module.exports = __webpack_public_path__ + "static/media/kia-bumper_selected.b8993fc2.svg";